import React, {useContext, useEffect, useState} from 'react'
import { Modal } from 'react-bootstrap';

import { VistaEmpresasContext } from '../../../Admin/consultora/VistaEmpresasAdmin';
import { useAdmin } from '../../../../context/AdminContext';

function ModalEmpresaConsul(props) {

    const { 
        user, 
        idEmpresa,
        setIdEmpresa,
        objEmpresa,
        setObjEmpresa,
    } = useContext(VistaEmpresasContext)
    
    const { fetchEmpresasById } = useAdmin()

    const [newEmpresa, setNewEmpresa] = useState({
        nombre: "",
        isBanco: "0"
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    useEffect(() => {
        if(objEmpresa){
            const obj = JSON.parse(objEmpresa)
            setNewEmpresa({
                nombre: obj.nombre,
                isBanco: obj.banco.toString()
            })
        }
    }, [objEmpresa])

    const handleClose = () => {
        setErrors({})
        setNewEmpresa({
            nombre: "",
            isBanco: "0"
        })
        setModalErr(null)
        setObjEmpresa(null)
        setIdEmpresa(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewEmpresa({
          ...newEmpresa,
          [name]: value,
        })
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba el nombre del empleado."
        }
        if(!data.isBanco.trim()) {
            errors.isBanco = "Elige una opción."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newEmpresa);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            const obj = {
                user,
                fk_consultora: user.idConsultora === 0 ? null : user.idConsultora,
                isBanco: parseInt(newEmpresa.isBanco),
                nombre: newEmpresa.nombre
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/addEmpresa`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.status !== 0){
                    setModalErr(data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewEmpresa({
                        nombre: "",
                        isBanco: "0"
                    })
                    setModalErr(null)
                    // actualizar empresas
                    // setLoadingEmpresas(true)
                    fetchEmpresasById(user, user.idConsultora)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend vvvvxv.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const handleChangeEmpresa = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newEmpresa);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            const obj = {
                user,
                id_empresa: idEmpresa,
                isBanco: parseInt(newEmpresa.isBanco),
                nombre: newEmpresa.nombre
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/organitation/editEmpresa`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                if(data.status !== 0){
                    setModalErr(data.codeError)
                } else {
                    props.onHide()
                    setErrors({})
                    setNewEmpresa({
                        nombre: "",
                        isBanco: "0"
                    })
                    setModalErr(null)
                    setObjEmpresa(null)
                    setIdEmpresa(null)
                    // actualizar empresas
                    // setLoadingEmpresas(true)
                    fetchEmpresasById(user, user.idConsultora)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__empresas'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    {objEmpresa ? <h3 className='m-0'>Modificar empresa</h3>: <h3 className='m-0'>Agregar empresa</h3>}
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {objEmpresa ? (
                    <form className='form__empresas d-flex flex-column' onSubmit={handleChangeEmpresa}>
                        <div className='mb-2 col-12'>
                            <label className='mb-1'>Nombre de la empresa</label>
                            <input 
                                onChange={handleChange}
                                type="text" 
                                id="nombre"
                                name='nombre'
                                autoFocus
                                className="form-control form-control-sm"
                                value={newEmpresa.nombre}
                            />
                            {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                        </div>
                        <div className='row mb-2'>
                            <div className='col-12 col-md-6'>
                                <label className='mb-1'>¿Es banco?</label>
                                <div className='d-flex flex-row'>
                                    <div className="form-check me-3">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="isBanco" 
                                            value="1"
                                            checked={newEmpresa.isBanco === "1"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">Sí</label>
                                    </div>
                                    <div className="form-check me-3">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="isBanco" 
                                            value="0" 
                                            checked={newEmpresa.isBanco === "0"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                        <button 
                            type='submit' 
                            className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                        >
                            Modificar empresa
                        </button>
                    </form>
                ) : (
                    <form className='form__empresas d-flex flex-column' onSubmit={handleSubmit}>
                        <div className='mb-2 col-12'>
                            <label className='mb-1'>Nombre de la empresa</label>
                            <input 
                                onChange={handleChange}
                                type="text" 
                                id="nombre"
                                name='nombre'
                                autoFocus
                                className="form-control form-control-sm"
                                value={newEmpresa.nombre}
                            />
                            {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                        </div>
                        <div className='row mb-2'>
                            <div className='col-12 col-md-6'>
                                <label className='mb-1'>¿Es banco?</label>
                                <div className='d-flex flex-row'>
                                    <div className="form-check me-3">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="isBanco" 
                                            value="1"
                                            checked={newEmpresa.isBanco === "1"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">Sí</label>
                                    </div>
                                    <div className="form-check me-3">
                                        <input 
                                            className="form-check-input" 
                                            type="radio" 
                                            name="isBanco" 
                                            value="0" 
                                            checked={newEmpresa.isBanco === "0"}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                        <button 
                            type='submit' 
                            className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                        >
                            Agregar empresa
                        </button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default ModalEmpresaConsul